import styled from 'styled-components'

const TextButton = styled.button.attrs(() => ({
  type: 'button',
}))`
  overflow: visible;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  font: inherit;
  line-height: 1;
  cursor: pointer;
  user-select: none;
  color: ${p => p.theme.colors.$scienceBlue};
  font-size: ${p => p.theme.fonts.$p3};
  font-weight: ${p => p.theme.weights.$semiBold};

  outline: 0;

  &:focus {
    outline: 0;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`

TextButton.displayName = 'TextButton'
export default TextButton
